import { DEV_REJECT_REASONS, REJECT_REASONS, assigneesOf } from './derive';

/** 테스크 리스트 = 인계 유형별 기본 항목(잠금) + 과제 항목 — 서버 TdTaskList 와 같은 규칙 */

export const BASE_ITEMS = {
  PD: ['Screen list', 'Priority per screen', 'Required data and copy', 'Open decisions'],
  DD: [
    'Screen states (default, empty, error)',
    'Spacing, color and component specs',
    'Asset export',
  ],
  QA: [
    'Core scenario works end to end',
    'Empty and error states handled',
    'Connected to the sample data',
    'Checked on a mobile screen',
    'Built and excluded scope',
    'Known bugs',
  ],
  MK: ['Key message', 'Screenshots', 'Target'],
  FINAL: ['All brief completion criteria', 'Rubric items'],
};

export const HANDOFF_TITLE = {
  PD: 'PM → Design',
  DD: 'Design → Development',
  QA: 'Development → PM (QA)',
  MK: 'Any → Marketing',
  FINAL: 'Final deliverable → Team lead Kim',
};

export const SOURCE_LABEL = { ops: 'Ops', pm: 'PM', pm_edit: 'PM edited' };

export const handoffTypeByJobs = (fromJob, toJob, isFinal) => {
  if (isFinal) return 'FINAL';
  if (toJob === 'marketer') return 'MK';
  if (fromJob === 'planner' && toJob === 'designer') return 'PD';
  if (fromJob === 'designer' && toJob === 'developer') return 'DD';
  if (fromJob === 'developer' && toJob === 'planner') return 'QA';
  return null;
};

/**
 * 태스크의 인계 유형 — 서버가 정해 둔 값(task.handoffType, 담당자를 다른 직무로 바꿔도 그대로)이 있으면 그것.
 * 받는 사람·담당자를 바꿔 보는 중(인자로 넘김)이거나 목 데이터면 직무로 정한다
 */
export const handoffTypeOf = (task, memberById, receiverId = task.receiverId, assigneeId) => {
  if (task.handoffType !== undefined && receiverId === task.receiverId && !assigneeId) {
    return task.isFinal ? 'FINAL' : task.handoffType;
  }
  const receiver = memberById.get(receiverId);
  return handoffTypeByJobs(
    memberById.get(assigneeId ?? assigneesOf(task)[0])?.job,
    receiver && receiver.role !== 'npc' ? receiver.job : null,
    !!task.isFinal,
  );
};

/** 이 태스크에서 고를 수 있는 반려 사유 — 개발 → PM(QA) 인계면 개발 사유 3개를 더한다 */
export const rejectReasonsFor = (task, memberById) =>
  handoffTypeOf(task, memberById) === 'QA'
    ? [...REJECT_REASONS.slice(0, -1), ...DEV_REJECT_REASONS, ...REJECT_REASONS.slice(-1)]
    : REJECT_REASONS;

export const baseItemsOf = (type) => BASE_ITEMS[type] ?? [];

export const typeOfBase = (base) =>
  Object.keys(BASE_ITEMS).find((k) => BASE_ITEMS[k][0] === base?.[0]) ?? null;

export const listOf = (task, memberById) => {
  const type = handoffTypeOf(task, memberById);
  const base = baseItemsOf(type);
  const items = (task.taskList ?? []).filter((x) => !base.includes(x));
  return { type, base, items, full: [...base, ...items], sources: task.taskSources ?? null };
};

const HOUR = 60 * 60 * 1000;

export const scopeRule = (task, now, due, teamStart) => {
  const free = now < teamStart;
  if (!free && task.state === 'submitted') {
    return { open: false, why: 'The Task List is locked while the handoff is in review.' };
  }
  if (!free && !['assigned', 'in_progress', 'rework_requested'].includes(task.state)) {
    return { open: false, why: 'This task is closed, so its Task List can’t change.' };
  }
  const deleteOnly = !free && now.getTime() >= due.getTime() - HOUR;
  return {
    open: true,
    free,
    deleteOnly,
    keepText: !free && (deleteOnly || task.state === 'rework_requested'),
  };
};
